import { Component, OnInit, ViewChild } from '@angular/core';
import { IonContent } from '@ionic/angular';
import { Navigator } from "src/app/services/routing/navigator";
import { WebcontentService } from 'src/app/services/webcontent/webcontent.service';

@Component({
  selector: 'app-popover-webview',
  templateUrl: './popover-webview.component.html',
  styleUrls: ['./popover-webview.component.scss'],
})
export class PopoverWebviewComponent implements OnInit {
  @ViewChild(IonContent, { static: false }) content: IonContent;

  public pageContent = "";
  public popOverTitle;
  public isIOSApp: boolean;

  constructor(
    public webContentService:WebcontentService,
    public navigator: Navigator,
  ){
    this.popOverTitle = this.navigator.activePopovers[this.navigator.activePopovers.length-1].componentProps.data.title;
  }

  ngOnInit(){
    const popoverUrl = (this.navigator.activePopovers[this.navigator.activePopovers.length-1].componentProps.data.url);
    this.webContentService.updateExternalLink(popoverUrl);
  }

  closePopover() {
    this.pageContent = "";
    this.navigator.activePopovers[this.navigator.activePopovers.length-1].dismiss();
  }
}
